import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';

export default function FloatingActionButton({ onClick }) {
  const [showPulse, setShowPulse] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPulse(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <button
      onClick={onClick}
      className="fixed bottom-24 right-4 z-30 md:hidden"
      aria-label="ნივთის დამატება"
    >
      <div className="relative">
        {showPulse && (
          <div className="absolute inset-0 rounded-full bg-pink-400 animate-ping opacity-75" />
        )}
        <div className={`
          w-[60px] h-[60px] rounded-full 
          bg-gradient-to-br from-pink-500 via-rose-500 to-pink-600 
          text-white shadow-2xl shadow-pink-500/40
          flex items-center justify-center
          transform hover:scale-110 active:scale-95
          transition-all duration-200
          touch-manipulation
        `}>
          <Plus className="w-7 h-7" strokeWidth={2.5} />
        </div>
      </div>
    </button>
  );
}